import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { Tooltip } from 'framework/ui/mui-builder';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  ExternalResource,
  useProjectSecurityContext,
} from 'domain/shared/newProject';
import { orderExternalResources } from '../../dashboard/List/orderExternalResources';
import Badge from '@mui/material/Badge';

interface MainInfoTitleProps {
  data: any;
  actions?: React.ReactNode;
  isEdit?: boolean;
}

const ProjectSectionHeader: React.FC<MainInfoTitleProps> = ({ data = {}, actions, isEdit = false }) => {
  const resources: ExternalResource[] | undefined = data?.resourcesData?.externalResources;
  const { isAccessGranted } = useProjectSecurityContext();
  const externalResources = useMemo(() => orderExternalResources(resources), [resources]);

  return (
    <>
      <Box width="100%">
        <Box display="flex" alignItems="center" justifyContent="space-between" gap={1} width="100%">
          {isAccessGranted(ACCESS_INFO_SECTIONS.PROJECT_SUMMARY, ACCESS_INFO_ACTIONS.VIEW) &&
          !data?.accountData?.sowId ? (
            <Badge
              color="error"
              sx={{ fontSize: '20px', '.MuiBadge-badge': { position: 'relative', transform: 'none' } }}
              badgeContent={'Without SOW'}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <Typography variant="h1" color="brand">
                {data?.name || 'New Project'}
              </Typography>
            </Badge>
          ) : (
            <Typography variant="h1" color="brand">
              {data?.name || 'New Project'}
            </Typography>
          )}
          <Box display="flex" flexDirection="column">
            {data.isArchived && isAccessGranted(ACCESS_INFO_SECTIONS.PROJECT_SUMMARY, ACCESS_INFO_ACTIONS.MANAGE) ? (
              <Box display="flex" justifyContent="flex-end" pr={1}>
                <Typography variant="caption" color="textSecondary">
                  Archived
                </Typography>
              </Box>
            ) : null}
            <Box display="flex" justifyContent="flex-end">
              {actions}
            </Box>

            {!isEdit && (
              <Box display="flex" flexDirection="row" justifyContent="flex-end" gap={2} pr={1}>
                {externalResources.map(({ value, config }) => (
                  <Tooltip key={value} title={config.displayName}>
                    <Link to={value} target="_blank" rel="noopener noreferrer">
                      <config.Icon />
                    </Link>
                  </Tooltip>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProjectSectionHeader;
